<template>
    <div class="outer-box" >
      <h4>Remove CR Token for Location</h4>
      <div class="inner-box content-box">
        <div>Enter Location ID
            <input
            class="hl_input--wrap"
            type="text"
            placeholder="Location ID"
            v-model="locationId"
            />
        </div>
        <div class="m-2">
            <input type="checkbox" v-model="android" />
            Android
        </div>
        <div class="m-2">
            <input type="checkbox" v-model="highLevelIOS" />
            HighLevel IOS
        </div>
        <div class="m-2">
            <input type="checkbox" v-model="leadConnectorIOS" />
            LeadConnector IOS
        </div>
        <div> Enter Custom IOS
          <input
          class="hl_input--wrap"
          type="text"
          placeholder="Custom IOS"
          v-model="customIOS"
        />
        </div>
        <button class="btn btn-danger mt-4" @click="removeToken">
          <moon-loader v-if="processing" :loading="true" class="button-loader" />
          <span v-else> Remove Token </span>
        </button>
        <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{response}}</pre>
      </div>
    </div>
  </template>
  
<script>
import config from "@/config";
import { SaasService } from '@/services';
export default {
  data() {
    return {
      locationId: '',
      android: false,
      highLevelIOS: false,
      leadConnectorIOS: false,
      customIOS: '',
      processing: false,
      response: null
    };
  },
  computed: {
    getHighLevelIOS() {
        return process.env.NODE_ENV === 'production' ? 'com.gohighlevel.reviews.voip' : 'com.gohighlevel.staging.voip';
    }
  },
  methods: {
    async removeToken() {
      this.processing = true;
      const value = {
          ios: {}
      };
      if (this.android)
        value.android = '';
      if (this.highLevelIOS)
        value.ios[this.getHighLevelIOS] = '';
      if (this.leadConnectorIOS)
        value.ios['com.LeadConnector.voip'] = '';
      if (this.customIOS)
        value.ios[this.customIOS] = '';
      SaasService.editTwilioAccount(this.locationId, {
        key: 'crToken',
        value,
        })
        .then(response => {
          this.response = "Success"
        })
        .catch(error => {
          this.response = error.response.data
        })
        .finally(() => {
          this.processing = false;
      });
    },
  }
}
</script>

<style scoped>
.button-loader {
  size: 21px;
  color: #fafafa;
}

.content-box {
  text-align: left;
  width: 500px;
}
</style>